import { useTranslation } from "@/hooks/useTranslation/useTranslation"

export interface PageIndicatorProps {
  /** `DeclarationDocumentViewer`'s `onCurrentPage` readout — null until the
   *  viewer reports its first scroll position. */
  current: number | null
  total: number | null
}

/** "S. cur/total" — the live, scroll-tracked page readout `DocumentPane`'s
 *  header shows beside `ZoomControl`. Renders nothing before the viewer's
 *  first report (a workbook pane, or a PDF still loading its first page). */
export function PageIndicator({ current, total }: PageIndicatorProps) {
  const { translate } = useTranslation()
  if (!current || !total) return null
  return (
    <span data-testid="page-indicator" className="sv2-n">
      {translate("MC_DECL_V2_PAGE_INDICATOR", { cur: current, total })}
    </span>
  )
}
